import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  CustomDialogProps,
  SmartForm,
  SmartSubmit,
  SmartTextField,
} from "@nodeon/react-components";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import { ApiResponse, ReturnNodeDto, useFileApi } from "~/api/GeneratedApi";

interface Props {
  node: ReturnNodeDto;
  onSubmitted?: () => void;
}

interface FormProps {
  name: string;
}

const RenameNodePopupForm = ({
  node,
  handleClose,
  onSubmitted,
}: CustomDialogProps & Props): JSX.Element => {
  const { t } = useTranslation("file-explorer");
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = () => {
    enqueueSnackbar(t("node-renamed"), {
      variant: "success",
    });
    handleClose?.();
    onSubmitted?.();
  };

  const fileApi = useFileApi();

  const onSubmit = (data: FormProps) => {
    return fileApi.renameItem({ newName: data.name }, node.id);
  };

  return (
    <Dialog open onClose={handleClose} aria-labelledby="form-dialog-title">
      <SmartForm<FormProps, ApiResponse>
        onSubmit={onSubmit}
        noGrid
        onSuccess={onSuccess}
        formProps={{
          defaultValues: { name: node.name ?? "" },
        }}
      >
        <DialogTitle id="form-dialog-title">
          {t("rename-node-title", { node: node.fullName })}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SmartTextField<FormProps>
                fullWidth
                name="name"
                label={t("new-name")}
                required
                autoFocus
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("general:cancel")}
          </Button>
          <SmartSubmit>{t("rename")}</SmartSubmit>
        </DialogActions>
      </SmartForm>
    </Dialog>
  );
};

export default RenameNodePopupForm;
